module.exports = __webpack_public_path__ + "img/ellipse.9d049c6b.svg";